module.exports = __webpack_public_path__ + "5158e9d51a5d214ad9aa96b196e172fa.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-0.png
// module id = 2897
// module chunks = 0